$(document).ready(function () {
  function sendGAEvent(eventName, eventLabel) {
    gtag("event", eventName, {
      event_category: "User Actions",
      event_label: eventLabel,
      value: 1,
      event_timestamp: Date.now(),
    });

    console.log(`${eventName} - Sent`);
  }

  $(document).on("click", ".ts-product__button", function () {
    console.log("======== PRODUCT STARTED TO ADDDING !!!");
    sendGAEvent("ProductStartAddingToCart-UPD", "Shoping flow");

    var cartOpened = 0;
    setInterval(function () {
      var cartDrawerOpened = $(".rebuy-cart").hasClass("is-visible");
      if (cartDrawerOpened == true) {
        if (cartOpened == 0) {
          console.log("======== PRODUCT ADDED TO CART !!!");
          sendGAEvent("ProductAddedToCart-UPD", "Shoping flow");
        }
        cartOpened = 1;
      }
    }, 500);
  });

  $(document).on("click", ".product_sticky-atc-btn", function () {
    console.log("======== STICKY BUTTON CLICKED !!!");
    sendGAEvent("ProductStickyButtonClicked-UPD", "Shoping flow");
  });

  var popupOfferVisible = 0;
  setInterval(function () {
    var ocuPopup = $(".ocu-popup").html();
    if (typeof ocuPopup != "undefined") {
      if (popupOfferVisible == 0) {
        console.log("======== UPSELL POPUP VISIBLE !!!");
        sendGAEvent("ProductPopupUpsellVisible-UPD", "Shoping flow");
      }
      popupOfferVisible = 1;
    }
  }, 500);
});
